import script from "./franchise.vue?vue&type=script&setup=true&lang=ts"
export * from "./franchise.vue?vue&type=script&setup=true&lang=ts"

import "./franchise.vue?vue&type=style&index=0&id=715d4b44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715d4b44"]])

export default __exports__